import { useEffect } from "react";

const DEFAULT_OG = "https://images.pexels.com/photos/30766302/pexels-photo-30766302.jpeg";

function upsertMeta(selector, attr, value, content) {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export default function SEO({ title, description, image, path = "" }) {
    const fullTitle = title ? `${title} — Cafe Hideout` : "Cafe Hideout — Great Coffee, Freshly Crafted";
    const desc = description || "A modern Indian cafe with South Indian coffee roots. Coffee, food, and community in Bengaluru, Mumbai, and Pune.";
    const og = image || DEFAULT_OG;

    useEffect(() => {
        document.title = fullTitle;
        const url = typeof window !== "undefined" ? `${window.location.origin}${path}` : "";

        upsertMeta('meta[name="description"]', "name", "description", desc);
        upsertMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
        upsertMeta('meta[property="og:description"]', "property", "og:description", desc);
        upsertMeta('meta[property="og:image"]', "property", "og:image", og);
        upsertMeta('meta[property="og:type"]', "property", "og:type", "website");
        if (url) upsertMeta('meta[property="og:url"]', "property", "og:url", url);
        upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
        upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);
        upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", desc);
        upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", og);
    }, [fullTitle, desc, og, path]);

    return null;
}
